export class NotificationSearchForm {
  constructor(
    public courseId?: string,
    public notificationStatus: string = '',
    public workerId?: string,
    public fromDate?: Date,
    public toDate?: Date,
    public category: string = 'All',
    public sortingOption: string = 'Newest to oldest') { }
}
